// packages/ui-lib/src/reset.css.ts
var reset = "reset__x5ky9i0";

export {
  reset
};
//# sourceMappingURL=chunk-TCD77MI5.js.map
